export class ResearchUnit {
  constructor(
    public hash?: string,
    public name?: string,
    public code?: string,
  ) {}

  clone() {
    return new ResearchUnit(
      this.hash,
      this.name,
      this.code
    );
  }
}
